// src/components/global/Table/EmptyStateRow.jsx
import React from 'react';
import { Box, TableRow, TableCell, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

const EmptyStateRow = ({ colSpan, isArabic, labelAr, labelEn }) => {
    return (
        <TableRow>
            <TableCell colSpan={colSpan} align="center" sx={{ py: 4 }}>
                <Box display="flex" flexDirection="column" alignItems="center" gap={1.5}>
                    <InboxIcon color="disabled" sx={{ fontSize: 40 }} />
                    <Typography variant="h6" color="text.secondary">
                        {isArabic ? labelAr : labelEn}
                    </Typography>
                    <Typography variant="body2" color="text.disabled">
                        {isArabic
                            ? 'لا توجد بيانات متاحة للعرض حاليًا.'
                            : 'There is currently no data to display.'}
                    </Typography>
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default EmptyStateRow;
